import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/SawitK.css";
import axios from "axios";
import Swal from "sweetalert2";

const SawitK = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const [jenisSawit, setJenisSawit] = useState([]);
  const [hargaSawit, setHargaSawit] = useState([]);
  const [isKebun] = useState(true);
  const [currentPageSawit, setCurrentSawit] = useState(1);
  const itemsPerPage = 5;

  // Modal states for Sawit
  const [showModal, setShowModal] = useState(false);
  const [nama, setNama] = useState("");
  const [usia, setUsia] = useState("");
  const [harga, setHarga] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);

  // Modal states for Pupuk
  const [hargaPupuk, setHargaPupuk] = useState([]);
  const [showPupukModal, setShowPupukModal] = useState(false);
  const [namaPupuk, setNamaPupuk] = useState("");
  const [hargaPupukPerKg, setHargaPupukPerKg] = useState("");
  const [deskripsiPupuk, setDeskripsiPupuk] = useState("");
  const [selectedPupukId, setSelectedPupukId] = useState(null);
  const [pupukErrorMessage, setPupukErrorMessage] = useState("");

  // Modal states for adding Sawit type
  const [showTambahSawitModal, setShowTambahSawitModal] = useState(false);
  const [namaSawit, setNamaSawit] = useState("");
  const [deskripsiSawit, setDeskripsiSawit] = useState("");
  const [tambahSawitErrorMessage, setTambahSawitErrorMessage] = useState("");

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const fetchSawitData = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_sawit",
        { withCredentials: true }
      );
      const sortedData = response.data.map((item) => {
        if (Array.isArray(item.harga_usia)) {
          item.harga_usia.sort((a, b) => a.usia - b.usia);
        } else {
          item.harga_usia = [];
        }
        return item;
      });
      setJenisSawit(sortedData);
      setHargaSawit(sortedData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const fetchPupukData = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/view_pupuk",
        { withCredentials: true }
      );
      setHargaPupuk(response.data.pupuks || []);
    } catch (error) {
      console.error("Error fetching pupuk data:", error);
    }
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchSawitData();
    fetchPupukData();
  }, []);

  const handlePageChangeSawit = (pageNumber) => {
    setCurrentSawit(pageNumber);
  };

  const totalPagesSawit = Math.ceil(jenisSawit.length / itemsPerPage);
  const currentSawitItems = jenisSawit.slice(
    (currentPageSawit - 1) * itemsPerPage,
    currentPageSawit * itemsPerPage
  );

  const handleShowModal = (item) => {
    setNama(item.nama);
    setUsia(item.usia || "");
    setHarga(item.harga || "");
    setSelectedItemId(item.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNama("");
    setUsia("");
    setHarga("");
    setErrorMessage("");
    setSelectedItemId(null);
  };

  const handleShowTambahSawitModal = () => {
    setSelectedItemId(null);
    setNama("");
    setUsia("");
    setHarga("");
    setShowModal(true);
  };

  const handleAddSawit = async () => {
    if (!nama || !usia || !harga) {
      setErrorMessage("Nama, usia, dan harga harus diisi!");
      return;
    }

    const payload = {
      nama: nama,
      usia: parseInt(usia),
      harga: parseFloat(harga),
    };

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/add_harga_sawit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 201) {
        fetchSawitData();
        handleCloseModal();
      } else {
        setErrorMessage(response.data.error || "Terjadi kesalahan, coba lagi.");
      }
    } catch (error) {
      setErrorMessage("Nama Sawit tidak ditemukan.");
      console.error(error);
    }
  };

  const handleEditSawit = async () => {
    if (!nama || !usia || !harga) {
      setErrorMessage("Nama, usia, dan harga harus diisi!");
      return;
    }

    const payload = {
      jenis_sawit_id: selectedItemId,
      usia: parseInt(usia),
      harga: parseFloat(harga),
    };

    try {
      const response = await axios.put(
        "https://c-greenproject.org:7500/edit_harga_sawit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        fetchSawitData();
        handleCloseModal();
        Swal.fire("Sukses", "Data berhasil diperbarui!", "success");
      } else {
        setErrorMessage(response.data.error || "Terjadi kesalahan, coba lagi.");
      }
    } catch (error) {
      setErrorMessage("Terjadi kesalahan saat mengirim data.");
      console.error(error);
    }
  };

  const handleAddPupuk = async () => {
    if (!namaPupuk || hargaPupukPerKg === "" || !deskripsiPupuk) {
      Swal.fire({
        icon: "warning",
        title: "Semua field harus diisi!",
        confirmButtonColor: "#198754",
      });
      return;
    }

    const payload = {
      nama: namaPupuk,
      harga_per_kg: parseFloat(hargaPupukPerKg),
      deskripsi: deskripsiPupuk,
    };

    try {
      await axios.post(
        "https://c-greenproject.org:7500/add_pupuk",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      Swal.fire({
        icon: "success",
        title: "Berhasil!",
        text: "Data pupuk berhasil ditambahkan.",
        confirmButtonColor: "#198754",
      });

      handleClosePupukModal();
      fetchPupukData();
    } catch (error) {
      const errorMsg =
        error.response?.data?.error ||
        "Terjadi kesalahan saat menambahkan data.";
      Swal.fire({
        icon: "error",
        title: "Gagal!",
        text: errorMsg,
        confirmButtonColor: "#dc3545",
      });
    }
  };

  const handleEditPupuk = async () => {
    if (!namaPupuk || hargaPupukPerKg === "" || !deskripsiPupuk) {
      setPupukErrorMessage("Nama, harga per kg, dan deskripsi harus diisi!");
      return;
    }

    const payload = {
      nama: namaPupuk,
      harga_per_kg: parseFloat(hargaPupukPerKg),
      deskripsi: deskripsiPupuk,
    };

    try {
      const response = await axios.put(
        `https://c-greenproject.org:7500/edit_pupuk/${selectedPupukId}`,
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        fetchPupukData();
        handleClosePupukModal();
        Swal.fire("Sukses", "Data berhasil diperbarui!", "success");
      } else {
        setPupukErrorMessage(response.data?.error || "Terjadi kesalahan.");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || "Terjadi kesalahan saat mengirim data.";
      setPupukErrorMessage(errorMessage);
      console.error(error);
    }
  };

  const handleClosePupukModal = () => {
    setShowPupukModal(false);
    setNamaPupuk("");
    setHargaPupukPerKg("");
    setDeskripsiPupuk("");
    setPupukErrorMessage("");
    setSelectedPupukId(null);
  };

  const handleDeletePupuk = async () => {
    const confirmDelete = await Swal.fire({
      title: "Hapus Data Pupuk?",
      text: "Yakin ingin menghapus data pupuk ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const response = await axios.delete(
        "https://c-greenproject.org:7500/delete_pupuk",
        {
          params: { id: selectedPupukId },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        fetchPupukData();
        handleClosePupukModal();
        Swal.fire("Sukses", "Data berhasil dihapus!", "success");
      } else {
        setPupukErrorMessage("Gagal menghapus data. Coba lagi.");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error || "Terjadi kesalahan saat menghapus data.";
      setPupukErrorMessage(errorMessage);
      console.error(error);
    }
  };

  const handleTambahSawit = async () => {
    if (!namaSawit || !deskripsiSawit) {
      setTambahSawitErrorMessage("Nama dan deskripsi jenis sawit harus diisi!");
      return;
    }

    const payload = {
      nama: namaSawit,
      deskripsi: deskripsiSawit,
    };

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/add_sawit",
        payload,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.status === 201) {
        Swal.fire("Sukses", "Jenis sawit berhasil ditambahkan!", "success");
        setShowTambahSawitModal(false);
        setNamaSawit("");
        setDeskripsiSawit("");
        setTambahSawitErrorMessage("");
        fetchSawitData();
      } else {
        setTambahSawitErrorMessage(
          response.data.error || "Terjadi kesalahan, coba lagi."
        );
      }
    } catch (error) {
      setTambahSawitErrorMessage(
        "Terjadi kesalahan saat menambah jenis sawit."
      );
      console.error(error);
    }
  };

  const handleDeleteSawit = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Hapus Jenis Sawit?",
      text: "Tindakan ini akan menghapus seluruh data jenis sawit terkait.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const response = await axios.delete(
        `https://c-greenproject.org:7500/delete_sawit?id=${id}`,
        { withCredentials: true }
      );
      if (response.status === 200) {
        Swal.fire("Sukses", "Jenis sawit berhasil dihapus!", "success");
        setJenisSawit((prev) => prev.filter((item) => item.id !== id));
      } else {
        Swal.fire("Gagal", "Terjadi kesalahan saat menghapus jenis sawit.", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Terjadi kesalahan saat menghapus jenis sawit.", "error");
      console.error(error);
    }
  };

  const handleDeleteHargaUsia = async (sawit) => {
    const usiaList = sawit.harga_usia.map((item) => item.usia);

    if (usiaList.length === 0) {
      Swal.fire("Info", "Tidak ada daftar harga pada jenis sawit ini.", "info");
      return;
    }

    const { value: usiaTerpilih } = await Swal.fire({
      title: `Hapus harga usia untuk ${sawit.nama}`,
      input: "select",
      inputOptions: usiaList.reduce((obj, usia) => {
        obj[usia] = `${usia} tahun`;
        return obj;
      }, {}),
      inputPlaceholder: "Pilih usia harga sawit yang ingin dihapus",
      showCancelButton: true,
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
      confirmButtonColor: "#dc3545",
    });

    if (usiaTerpilih) {
      const payload = {
        nama: sawit.nama,
        usia: parseInt(usiaTerpilih),
      };

      try {
        const response = await axios.delete(
          "https://c-greenproject.org:7500/delete_harga_sawit",
          {
            data: payload,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );

        if (response.status === 200) {
          Swal.fire(
            "Sukses",
            response.data.message || "Harga sawit berhasil dihapus!",
            "success"
          );
          fetchSawitData();
        } else {
          Swal.fire(
            "Gagal",
            response.data.error || "Gagal menghapus harga sawit",
            "error"
          );
        }
      } catch (error) {
        console.error("Gagal menghapus harga sawit:", error);
        const errorMsg =
          error.response?.data?.error || "Terjadi kesalahan.";
        Swal.fire("Error", errorMsg, "error");
      }
    }
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/kebun")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/kebun" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/kebun" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/KebunP")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.includes("/kebunPRP") || location.pathname === "/KebunP"
                  ? "bg-success text-white"
                  : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px", filter: location.pathname.includes("/kebunPRP") || location.pathname === "/KebunP" ? "brightness(0) invert(1)" : "none" }} /> Petani
            </div>
            <div
              onClick={() => navigate("/KebunL")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/KebunL" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/shipping.png" alt="Harvest" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/KebunL" ? "brightness(0) invert(1)" : "none" }} /> Logistik
            </div>
            <div
              onClick={() => navigate("/pabrik")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/pabrik" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/factory.png" alt="Factory" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/pabrik" ? "brightness(0) invert(1)" : "none" }} /> Pabrik
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Manajemen Harga Sawit & Pupuk</h2>
            <button className="btn kembali-button px-4" onClick={handleBack}>
              Kembali
            </button>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Harga Sawit */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white mb-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4 pb-3 border-bottom">
              <h4 className="fw-bold text-success mb-0">Daftar Harga Sawit</h4>

              {isKebun && (
                <div className="d-flex flex-wrap gap-2">
                  <button
                    className="btn btn-outline-secondary rounded-pill px-4 fw-medium text-nowrap shadow-sm"
                    onClick={() => setShowTambahSawitModal(true)}
                  >
                    <i className="fa fa-plus me-2"></i>Tambah Jenis Sawit
                  </button>
                  <button
                    className="btn btn-success rounded-pill px-4 fw-medium text-nowrap shadow-sm"
                    onClick={handleShowTambahSawitModal}
                  >
                    <i className="fa fa-tag me-2"></i>Tambah Harga Sawit
                  </button>
                </div>
              )}
            </div>

            {currentSawitItems && currentSawitItems.length > 0 ? (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle" style={{ minWidth: "900px" }}>
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                      <th className="py-3" style={{ width: "160px" }}>Nama</th>
                      <th className="py-3" style={{ width: "150px" }}>Harga Per Kg</th>
                      <th className="py-3" style={{ width: "120px" }}>Usia</th>
                      <th className="py-3" style={{ width: "160px" }}>Tanggal Diperbarui</th>
                      <th className="py-3">Deskripsi</th>
                      <th className="text-center py-3" style={{ width: "160px", borderTopRightRadius: "10px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentSawitItems.map((item, index) => (
                      <tr key={`sawit-${item.id || index}`}>
                        <td className="text-center fw-bold text-muted">
                          {(currentPageSawit - 1) * itemsPerPage + index + 1}
                        </td>
                        <td className="fw-bold text-dark text-capitalize">
                          {item.nama}
                        </td>
                        <td>
                          {Array.isArray(item.harga_usia) && item.harga_usia.length > 0 ? (
                            item.harga_usia.map((data, idx) => (
                              <div key={`harga-${item.id}-${idx}`} className="py-1 font-monospace text-success fw-semibold">
                                Rp {Number(data.harga).toLocaleString("id-ID")}
                              </div>
                            ))
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          {Array.isArray(item.harga_usia) && item.harga_usia.length > 0 ? (
                            item.harga_usia.map((data, idx) => (
                              <div key={`usia-${item.id}-${idx}`} className="py-1 text-muted">
                                {data.usia} Tahun
                              </div>
                            ))
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td>
                          {Array.isArray(item.harga_usia) && item.harga_usia.length > 0 ? (
                            item.harga_usia.map((data, idx) => (
                              <div key={`tgl-${item.id}-${idx}`} className="py-1 text-muted small">
                                {new Date(data.tanggal).toLocaleString("id-ID", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </div>
                            ))
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                        <td className="text-muted">
                          {item.deskripsi || "-"}
                        </td>
                        
                        {isKebun ? (
                          <td className="text-center">
                            <div className="d-flex flex-column gap-2">
                              <button
                                className="btn btn-outline-warning btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                                onClick={() => handleShowModal(item)}
                              >
                                Edit Harga
                              </button>
                              <button
                                className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                                onClick={() => handleDeleteSawit(item.id)}
                              >
                                Hapus Jenis
                              </button>
                              <button
                                className="btn btn-outline-danger btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                                onClick={() => handleDeleteHargaUsia(item)}
                              >
                                Hapus Harga
                              </button>
                            </div>
                          </td>
                        ) : (
                          <td className="text-center">-</td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3">
                <i className="fa fa-seedling mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Data Sawit</h5>
                <p className="mb-0">Data harga sawit belum tersedia saat ini.</p>
              </div>
            )}

            {/* Pagination Sawit */}
            <nav className="mt-4">
              <ul className="pagination justify-content-end mb-0">
                <li className={`page-item ${currentPageSawit === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link shadow-none rounded-start-pill"
                    onClick={() => handlePageChangeSawit(currentPageSawit - 1)}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPagesSawit)].map((_, index) => (
                  <li
                    key={`page-sawit-${index + 1}`}
                    className={`page-item ${
                      currentPageSawit === index + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link shadow-none"
                      onClick={() => handlePageChangeSawit(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPageSawit === totalPagesSawit || totalPagesSawit === 0
                      ? "disabled"
                      : ""
                  }`}
                >
                  <button
                    className="page-link shadow-none rounded-end-pill"
                    onClick={() => handlePageChangeSawit(currentPageSawit + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>

          {/* Table Container Harga Pupuk */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4 pb-3 border-bottom">
              <h4 className="fw-bold text-success mb-0">Daftar Harga Pupuk</h4>
              <button
                className="btn btn-success rounded-pill px-4 fw-medium text-nowrap shadow-sm"
                onClick={() => setShowPupukModal(true)}
              >
                <i className="fa fa-box me-2"></i>Tambah Harga Pupuk
              </button>
            </div>

            {Array.isArray(hargaPupuk) && hargaPupuk.length > 0 ? (
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle" style={{ minWidth: "800px" }}>
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center py-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                      <th className="py-3" style={{ width: "180px" }}>Nama</th>
                      <th className="py-3" style={{ width: "160px" }}>Harga per Kg</th>
                      <th className="py-3">Deskripsi</th>
                      <th className="text-center py-3" style={{ width: "120px", borderTopRightRadius: "10px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hargaPupuk.map((pupuk, index) => (
                      <tr key={`pupuk-${pupuk.id || index}`}>
                        <td className="text-center fw-bold text-muted">{index + 1}</td>
                        <td className="fw-bold text-dark">{pupuk.nama}</td>
                        <td className="font-monospace text-success fw-semibold">
                          Rp {Number(pupuk.harga_per_kg).toLocaleString("id-ID")}
                        </td>
                        <td className="text-muted">{pupuk.deskripsi || "-"}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-outline-warning btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                            onClick={() => {
                              setNamaPupuk(pupuk.nama);
                              setHargaPupukPerKg(pupuk.harga_per_kg);
                              setDeskripsiPupuk(pupuk.deskripsi);
                              setSelectedPupukId(pupuk.id);
                              setShowPupukModal(true);
                            }}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3">
                <i className="fa fa-boxes mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Data Pupuk</h5>
                <p className="mb-0">Data harga pupuk belum tersedia saat ini.</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal Tambah Jenis Sawit */}
      {showTambahSawitModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">Tambah Jenis Sawit</h5>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  onClick={() => setShowTambahSawitModal(false)}
                ></button>
              </div>
              <div className="modal-body px-4 py-3">
                {tambahSawitErrorMessage && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3">
                    {tambahSawitErrorMessage}
                  </div>
                )}
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2" htmlFor="namaSawit">Nama Jenis Sawit</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    id="namaSawit"
                    value={namaSawit}
                    onChange={(e) => setNamaSawit(e.target.value)}
                    placeholder="Masukkan nama jenis sawit"
                  />
                </div>
                <div className="form-group mb-0">
                  <label className="fw-semibold text-muted mb-2" htmlFor="deskripsiSawit">Deskripsi</label>
                  <textarea
                    className="form-control rounded-3"
                    id="deskripsiSawit"
                    rows="3"
                    value={deskripsiSawit}
                    onChange={(e) => setDeskripsiSawit(e.target.value)}
                    placeholder="Masukkan deskripsi jenis sawit"
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4 fw-medium"
                  onClick={() => setShowTambahSawitModal(false)}
                >
                  Batal
                </button>
                <button
                  type="button"
                  className="btn btn-success rounded-pill px-4 fw-bold shadow-sm"
                  onClick={handleTambahSawit}
                >
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Tambah / Edit Harga Sawit */}
      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">
                  {selectedItemId ? "Edit Harga Sawit" : "Tambah Harga Sawit"}
                </h5>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body px-4 py-3">
                {errorMessage && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3">{errorMessage}</div>
                )}
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2" htmlFor="nama">Nama</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    id="nama"
                    value={nama}
                    onChange={(e) => setNama(e.target.value)}
                    placeholder="Masukkan Nama"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2" htmlFor="usia">Usia (tahun)</label>
                  <input
                    type="number"
                    className="form-control form-control-lg rounded-3 fs-6"
                    id="usia"
                    value={usia}
                    onChange={(e) => setUsia(e.target.value)}
                    placeholder="Masukkan Usia"
                  />
                </div>
                <div className="form-group mb-0">
                  <label className="fw-semibold text-muted mb-2" htmlFor="harga">Harga</label>
                  <input
                    type="number"
                    className="form-control form-control-lg rounded-3 fs-6"
                    id="harga"
                    value={harga}
                    onChange={(e) => setHarga(e.target.value)}
                    placeholder="Masukkan Harga"
                  />
                </div>
              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button
                  type="button"
                  className="btn btn-light rounded-pill px-4 fw-medium"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-pill px-4 fw-bold shadow-sm"
                  onClick={selectedItemId ? handleEditSawit : handleAddSawit}
                >
                  {selectedItemId ? "Update" : "Tambah"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Tambah / Edit Harga Pupuk */}
      {showPupukModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">
                  {selectedPupukId ? "Edit Harga Pupuk" : "Tambah Harga Pupuk"}
                </h5>
                <button
                  type="button"
                  className="btn-close shadow-none"
                  onClick={handleClosePupukModal}
                ></button>
              </div>
              <div className="modal-body px-4 py-3">
                {pupukErrorMessage && (
                  <div className="alert alert-danger rounded-3 py-2 px-3 mb-3">
                    {pupukErrorMessage}
                  </div>
                )}
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2" htmlFor="namaPupuk">Nama</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    id="namaPupuk"
                    value={namaPupuk}
                    onChange={(e) => setNamaPupuk(e.target.value)}
                    placeholder="Masukkan Nama"
                  />
                </div>
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted mb-2" htmlFor="hargaPupuk">Harga per Kg</label>
                  <input
                    type="number"
                    className="form-control form-control-lg rounded-3 fs-6"
                    id="hargaPupuk"
                    value={hargaPupukPerKg}
                    onChange={(e) => setHargaPupukPerKg(e.target.value)}
                    placeholder="Masukkan Harga"
                  />
                </div>
                <div className="form-group mb-0">
                  <label className="fw-semibold text-muted mb-2" htmlFor="deskripsiPupuk">Deskripsi</label>
                  <input
                    type="text"
                    className="form-control form-control-lg rounded-3 fs-6"
                    id="deskripsiPupuk"
                    value={deskripsiPupuk}
                    onChange={(e) => setDeskripsiPupuk(e.target.value)}
                    placeholder="Masukkan Deskripsi"
                  />
                </div>
              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4 justify-content-between">
                <div>
                  {selectedPupukId && (
                    <button
                      type="button"
                      className="btn btn-outline-danger rounded-pill px-4 fw-medium shadow-sm"
                      onClick={handleDeletePupuk}
                    >
                      Hapus
                    </button>
                  )}
                </div>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-light rounded-pill px-4 fw-medium"
                    onClick={handleClosePupukModal}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill px-4 fw-bold shadow-sm"
                    onClick={selectedPupukId ? handleEditPupuk : handleAddPupuk}
                  >
                    {selectedPupukId ? "Update" : "Tambah"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SawitK;